import { Host, h } from '@stencil/core';
export class AibaProductRatings {
  constructor() {
    this.data = undefined;
    this.sku = undefined;
    this.handlers = undefined;
    this.classes = undefined;
    this.upc = undefined;
    this.template = undefined;
    this.productName = undefined;
    this.styles = undefined;
    this.productRatingService = undefined;
    this.productRatingEnabled = undefined;
    this.productRatingData = undefined;
  }
  async componentDidLoad() {
    if (this.handlers && this.handlers.handleProductRatingsOnLoad) {
      const { productRatingsApi, productRatingsApiData, enabled } = await this.handlers.handleProductRatingsOnLoad();
      this.productRatingService = productRatingsApi;
      this.productRatingData = productRatingsApiData;
      this.productRatingEnabled = enabled;
      if (this.sku) {
        this.sku = this.sku.length > 12 ? this.sku.substring(2) : this.sku;
      }
    }
  }
  render() {
    var _a;
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "product-rating-wrapper" }, this.data &&
      this.productRatingEnabled &&
      ((_a = this.data.elements) === null || _a === void 0 ? void 0 : _a.map((component) => {
        var _a;
        if (component && component['name'] === 'aiba-bazaarvoice-ratings' && this.productRatingService === 'bazaarvoice')
          return (h("div", { class: "bv" }, h("aiba-bazaarvoice-ratings", { upc: this.upc, summary: ((_a = this.productRatingData) === null || _a === void 0 ? void 0 : _a.variation) === 'summary' }), h("aiba-bazaarvoice-script", { upc: this.upc, bvData: this.productRatingData })));
        if (component && component['name'] === 'aiba-kritique-ratings' && this.productRatingService === 'kritique')
          return (h("div", { class: "kritique" }, h("aiba-kritique-ratings", { sku: this.sku, upc: this.upc, productName: this.productName, kritiqueData: this.productRatingData }), h("aiba-kritique-script", { upc: this.upc, kritiqueData: this.productRatingData })));
      })))));
  }
  static get is() { return "aiba-product-ratings"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-product-ratings.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-product-ratings.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "sku": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "sku",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "upc": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "upc",
        "reflect": false
      },
      "template": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "template",
        "reflect": false
      },
      "productName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-name",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "productRatingService": {},
      "productRatingEnabled": {},
      "productRatingData": {}
    };
  }
}
//# sourceMappingURL=aiba-product-ratings.js.map
